import { render, staticRenderFns } from "./TextChanger.vue?vue&type=template&id=740100b8"
import script from "./TextChanger.vue?vue&type=script&lang=js"
export * from "./TextChanger.vue?vue&type=script&lang=js"
import style0 from "./TextChanger.vue?vue&type=style&index=0&id=740100b8&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports